import React from "react";
import { useRouter } from "next/router";

import { useProjectSearch } from "src/hooks/useProjectSearch";

const NoMatches = () => {
  const query = useRouter().query;
  const search = useProjectSearch();

  return (
    <div className="no-matches">
      <div className="no-matches-header">No matches</div>
      Please broaden your search...
      {query.query && (
        <span>
          try{" "}
          <a className="text-link" onClick={() => search({ query: undefined })}>
            clearing your query
          </a>
          .
        </span>
      )}
    </div>
  );
};

export default NoMatches;
